<div class="lmo-frac-home" *ngIf="currentFrac$ | async as currentFrac">
  <div class="report-warning-container" *ngIf="(currentFracReport$ | async)?.available === false" [@slideInAndOut]>
    <sa-lmo-well-status-warning [report]="currentFracReport$ | async"></sa-lmo-well-status-warning>
  </div>
  <div class="flex flex-col mainView">
    <section>
      <sa-lmo-frac-home-sandi-status [frac]="currentFrac"></sa-lmo-frac-home-sandi-status>
    </section>
    <div class="my-2">
      <sa-lmo-frac-home-storage-prediction
        class="prediction"
        [frac]="currentFrac$ | async"
        [fracGraph]="currentFracGraph$ | async"
      ></sa-lmo-frac-home-storage-prediction>
    </div>
  </div>
  <main>
    <div class="col1">
      <div class="mb-2">
        <sa-lmo-frac-home-trucking-vendors [frac]="currentFrac"></sa-lmo-frac-home-trucking-vendors>
      </div>
      <div class="mb-2">
        <sa-lmo-frac-home-hse-requirements [frac]="currentFrac"></sa-lmo-frac-home-hse-requirements>
      </div>
      <div class="mb-2">
        <sa-lmo-frac-home-coordinates [frac]="currentFrac"></sa-lmo-frac-home-coordinates>
      </div>
      <div class="mb-2">
        <sa-lmo-frac-home-directions [frac]="currentFrac"></sa-lmo-frac-home-directions>
      </div>
    </div>
    <div class="col2">
      <div class="mb-2">
        <sa-lmo-frac-home-purchase-orders [frac]="currentFrac"></sa-lmo-frac-home-purchase-orders>
      </div>
      <div class="mb-2">
        <sa-lmo-frac-home-auto-dispatch-toggle></sa-lmo-frac-home-auto-dispatch-toggle>
      </div>
      <div style="margin-bottom: 8rem;">&nbsp;</div>
    </div>
  </main>
</div>
<div class="new-order-button">
  <sa-lmo-frac-home-update-button></sa-lmo-frac-home-update-button>
</div>
<router-outlet></router-outlet>
